import './TermsAndConditions.css';
import React from 'react';

import config from '@config';
import Metas from '@views/Metas';

import termsContent from './termsContent';

export const TermsAndConditions = () => (
  <div className="TermsAndConditions">
    <Metas
      title="Términos y condiciones — Prode 2026"
      description="Términos y condiciones del Prode 2026 de Página/12."
      path="terms-and-conditions"
    />

    <div className="hero-bg">
      <div className="hero-content">
        <h2>Términos y condiciones</h2>
      </div>
    </div>

    <div className="terms-content">
      <div className="terms-content__inner">
        <div
          className="terms-html"
          dangerouslySetInnerHTML={{ __html: termsContent }}
        />
      </div>
    </div>
  </div>
);

TermsAndConditions.displayName = 'TermsAndConditions';

export default TermsAndConditions;